import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 480,
            md: 768,
            lmd: 1024,
            lmg: 1216,
            lg: 1280,
            xl: 1440,
        },
    },
    typography: {
        fontFamily: 'Geologica, Arial, sans-serif',
        h2Bold: {
            fontSize: '34px',
            lineHeight: 1.25,
            fontWeight: 700,
        },
        h4Bold: {
            fontSize: '28px',
            fontWeight: 700,
        },
        body1Medium: {
            fontSize: '22px',
            lineHeight: 1.25,
            fontWeight: 500,
        },
        body2Medium: {
            fontSize: '20px',
            lineHeight: 1.25,
            fontWeight: 500,
        },
        body2Bold: {
            fontSize: '20px',
            lineHeight: 1.25,
            fontWeight: 700,
        },
        body3Light: {
            fontSize: '18px',
            lineHeight: 1.25,
            fontWeight: 300,
        },
        body3Medium: {
            fontSize: '18px',
            lineHeight: 1.25,
            fontWeight: 500,
        },
        body4Light: {
            fontSize: '16px',
            lineHeight: 1.25,
            fontWeight: 300,
        },
        body4Medium: {
            fontSize: '16px',
            lineHeight: 1.25,
            fontWeight: 500,
        },
        body4Bold: {
            fontSize: '16px',
            lineHeight: 1.25,
            fontWeight: 700,
        },
        captionLight: {
            fontSize: '14px',
            lineHeight: 1.225,
            fontWeight: 300,
        },
        captionSmall: {
            fontSize: '12px',
            lineHeight: 1.25,
            fontWeight: 200,
        },
    },
    palette: {
        mode: 'dark',
        background: {
            default: '#0C0F21',
            white: '#fff',
            blue: '#0666BB',
            gray: '#12162B',
        },
        text: {
            black: '#2D3137',
            grey: '#A3A5B0',
            error: '#FB5959',
            azure: '#539AB3',
            lightBlue: '#01CFFE',
            lightGray: '#72789A',
            darkGrey: '#454B6F',
            blackLighter: '#383838',
            disableLight: '#D3D3DD',
            disableDark: '#72789A',
            totalBlack: '#000000',
        },
    },
});

export default theme;
